export class IntegrationAndPositionInfo{
    positionID : string;
    choosedOrganizationIntegrationIdList : string[];
}